import { useContext } from "react";
import { SurveyFormContext } from "@/components/common/resource-survey/components/survey-form/survey-form-context";
import { defaultSurveyRangeTooltip } from "@/components/common/resource-survey/components/survey-form/components/survey-question/presets/data";
import { cn } from "@/lib/utils";

export const SurveyRangeInput = ({
  steps,
  handleStepClick,
  value,
  tooltipMap,
}: {
  steps: number[];
  handleStepClick: (stepValue: number) => void;
  value: number | null;
  tooltipMap: any;
}) => (
  <div className={"mb-4 flex gap-1.5 rounded-lg"}>
    {steps.map((stepValue, index) => (
      <div
        key={index}
        onClick={() => handleStepClick(stepValue)}
        className={cn(
          "flex h-[42px] w-full items-center justify-center gap-2 rounded-lg border border-zinc-500 px-2 py-4 text-center hover:cursor-pointer",
          stepValue === value && "bg-remedium-blue text-white",
        )}
        {...(tooltipMap ? { "data-title": tooltipMap[index] } : {})}
      >
        {stepValue}
      </div>
    ))}
  </div>
);

export const SurveyRange = ({
  payload: { min, max, step },
  index,
}: {
  payload: SurveyNodePayloadRangeVM;
  index: number;
}) => {
  const { setStepsAnswers, stepsAnswers, currentStep } =
    useContext(SurveyFormContext);

  const stepAnswers = stepsAnswers[currentStep];
  const { value } = stepAnswers[index] as { value: number | null };

  // Generate an array of values from min to max with the given step
  const steps = [];
  for (let i = min; i <= max; i += step) {
    steps.push(i);
  }

  const handleStepClick = (stepValue: number) => {
    setStepsAnswers((draft) => {
      draft[currentStep][index].value = stepValue;
    });
  };

  const tooltipMap =
    min === 1 && max === 5 && step === 1 ? defaultSurveyRangeTooltip : false;

  return (
    <SurveyRangeInput
      value={value}
      tooltipMap={tooltipMap}
      steps={steps}
      handleStepClick={handleStepClick}
    />
  );
};
